var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function getActiveTermProfile(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        return getTermProfile(ctx, companyId, "active");
    });
}
export function getTermProfile(c, companyId, term) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield c.client.fetch(c.baseUrl.joinPath("/v1/manage/organizations", companyId, "terms", term.toString()), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = (yield res.json());
        return {
            id: data.term_id,
            term_start_date: new Date(data.term_start_date),
            term_end_date: new Date(data.term_end_date),
            payleo_repayments_date: new Date(data.payleo_repayments_date),
            next_term_start_date: data.next_term_start_date
                ? new Date(data.next_term_start_date)
                : null,
        };
    });
}
